import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, vShow as _vShow, normalizeStyle as _normalizeStyle, createBlock as _createBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-abc10584"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "windows-container" }
const _hoisted_2 = { class: "task-bar" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "btn-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Window = _resolveComponent("Window")!
  const _component_sc_icon = _resolveComponent("sc-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.windows, (window, index) => {
      return _withDirectives((_openBlock(), _createBlock(_component_Window, {
        key: index,
        "window-datum": window,
        onMinimize: ($event: any) => (_ctx.minimize(window)),
        onActive: ($event: any) => (_ctx.active(window)),
        onClose: ($event: any) => (_ctx.closeWindow(window.id, $event)),
        onSetReturnData: ($event: any) => (_ctx.setReturnData(window.id, $event)),
        style: _normalizeStyle({ 'z-index': window.zIndex })
      }, null, 8, ["window-datum", "onMinimize", "onActive", "onClose", "onSetReturnData", "style"])), [
        [_vShow, !window.mini]
      ])
    }), 128)),
    _withDirectives(_createElementVNode("div", {
      class: "mask",
      style: _normalizeStyle({ zIndex: _ctx.maxZIndex - 1 })
    }, null, 4), [
      [_vShow, _ctx.isMask]
    ]),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.miniWindows, (id, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "task",
          key: index
        }, [
          _createElementVNode("div", {
            class: "title",
            onClick: ($event: any) => (_ctx.normalize(_ctx.windows[id]))
          }, _toDisplayString(_ctx.windows[id].title), 9, _hoisted_3),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_sc_icon, {
              class: "btn",
              type: "CloseOutlined",
              onClick: ($event: any) => (_ctx.closeWindow(id))
            }, null, 8, ["onClick"])
          ])
        ]))
      }), 128))
    ])
  ]))
}